// This file is generated by a script. Do not edit this file directly.
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.Attachment = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.Attachment = void 0;
  _react = _interopRequireDefault(_react);
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
  function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
  var Attachment = _exports.Attachment = function Attachment(props) {
    return /*#__PURE__*/_react["default"].createElement("svg", _extends({
      viewBox: "0 0 20 20"
    }, props), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M8.58832 18.1251C6.99666 18.1251 5.51415 17.5176 4.41332 16.4143C2.09165 14.086 2.12764 10.2618 4.49347 7.89013L9.26683 3.10347C10.056 2.3118 11.1067 1.87598 12.2234 1.87598C13.34 1.87598 14.391 2.3118 15.1801 3.10347C16.8085 4.7368 16.8085 7.39431 15.1801 9.02764L10.3834 13.8368C9.4767 14.7468 7.89432 14.7476 6.98432 13.8368C6.04849 12.8985 6.04849 11.3718 6.98432 10.4335L11.1976 6.20848C11.4417 5.96431 11.8376 5.96347 12.0818 6.20764C12.3268 6.45097 12.3267 6.84681 12.0834 7.09181L7.87014 11.3168C7.41931 11.7685 7.41931 12.5035 7.87014 12.9551C8.30431 13.3918 9.06419 13.391 9.49836 12.9551L14.2951 8.14597C15.4384 6.9993 15.4384 5.13347 14.2951 3.9868C13.1884 2.8768 11.2593 2.8768 10.1527 3.9868L5.3793 8.77348C3.53013 10.6268 3.49414 13.7226 5.29914 15.5326C6.16331 16.3993 7.33082 16.876 8.58832 16.876C9.87749 16.876 11.1333 16.3576 12.035 15.4535L16.2242 11.2518C16.4676 11.0076 16.8634 11.0068 17.1084 11.251C17.3534 11.4943 17.3534 11.8901 17.1101 12.1351L12.9208 16.3368C11.7858 17.4726 10.2067 18.1251 8.58832 18.1251Z",
      fill: "#212B36"
    }));
  };
});
